import styled from 'styled-components';
import { onSurface, primary, surfaceContainer, outlineVariant, popoverShadow } from '../themeTokens';

export const Panel = styled.div`
  position: absolute;
  bottom: calc(100% + 14px);
  left: 50%;
  translate: -50% 0;
  z-index: 3;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: min(248px, calc(100cqw - 24px));
  padding: 14px;
  border: 1px solid ${outlineVariant};
  border-radius: 18px;
  background: ${surfaceContainer};
  color: ${onSurface};
  box-shadow: ${popoverShadow};
  font-size: 12px;
`;

export const Presets = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Preset = styled.button<{ $color: string; $active: boolean }>`
  width: 22px;
  height: 22px;
  padding: 0;
  border-radius: 50%;
  border: 2px solid ${(p) => (p.$active ? primary(p) : outlineVariant(p))};
  background: ${(p) => p.$color};
  box-shadow: ${(p) => (p.$active ? `0 0 0 2px color-mix(in srgb, ${primary(p)} 30%, transparent)` : 'none')};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${primary};
    outline-offset: 2px;
  }
`;
